import styled from 'styled-components';
import theme from '../theme';
import fn from '../../helpers/fn';

export default fn(__filename, styled.div`
  margin: 0 auto;
  max-width: ${100 * theme.unit}px;
  padding: ${5 * theme.unit}px;
  flex: 1;
  width: 100%;
  box-sizing: border-box;
`);



// WEBPACK FOOTER //
// ./src/components/blocks/Page.js